<div class="{{className}}">
<table mat-table [dataSource]="dataSource" class="itb-table">
    <ng-container *ngFor="let col of displayedColumns" matColumnDef="{{col}}" >
        <th class="table-h" mat-header-cell *matHeaderCellDef mat-sort-header> {{col}} </th>
        <div [ngSwitch]="col">
            <div *ngSwitchCase="'hand'">
                <td mat-cell *matCellDef="let element">
                    <itb-image [src]="element.hand.imagePath" [imageHeight]="element.hand.imageHeight" [imageWidth]="element.hand.imageWidth"></itb-image>
                </td>
            </div>
            <div *ngSwitchCase="'permissions'">
                <td mat-cell *matCellDef="let element">
                    <mat-chip-list>
                        <itb-chip *ngFor="let chip of element.permissions" [tooltipText]="chip.tooltipText"
                                  [className]="chip.className" [text]="chip.text">
                        </itb-chip>
                    </mat-chip-list>
                </td>
            </div>
            <div *ngSwitchCase="'actions'">
                <td mat-cell *matCellDef="let element">
                    <itb-icon *ngFor="let action of element.actions" [tooltipText]="action.tooltipText"
                              [className]="action.className" (click)="actionClickEvent(element, action.name)">
                    </itb-icon>
                </td>
            </div>
            <div *ngSwitchCase="'ticket'"> 
                <td mat-cell *matCellDef="let element">
                    <a href="{{element.link}}" [target]="openInNewTab ? '_blank' : '_self'" rel="noopener">{{element[col]}}</a>
                </td>
            </div>
            <div *ngSwitchCase="'show as popup'">
                <td mat-cell *matCellDef="let element">
                    <itb-switch [isReactive]="false" [hasDivider]="false" [isDisabled]="element.switch.isDisabled" [value]="element.switch.value" (onChangeHandler)="switchClickEvent(element, $event.checked)">
                    </itb-switch>
                </td>
            </div>
            <div *ngSwitchCase="'group'">
                <td mat-cell *matCellDef="let element">
                    <itb-select [isReactive]="false" [isDisabled]="element.group.isDisabled" [label]="element.group.label" [items]="element.group.items" [isMultiple]="element.group.isMultiple" [itemsStringArray]="element.group.itemsStringArray" [isDataInStrings]="element.group.isDataInStrings" [selected]="element.group.selected" [isSelectWithObjects]="element.group.isSelectWithObjects" [isRequired]="element.group.isRequired" [isSorted]="element.group.isSorted" (onChangeHandler)="selectClickEvent($event)" (onSimpleChangeHandler)="simpleSelectEvent($event)" >
                    </itb-select>
                </td>
            </div>
            <div *ngSwitchDefault>
                <ng-container *ngIf="!hasInnerHTML">
                    <td mat-cell *matCellDef="let element" (click)="textClickEvent(element)"> {{element[col]}} </td>
                </ng-container>
                <ng-container *ngIf="hasInnerHTML">
                    <td mat-cell *matCellDef="let element" [innerHTML]="getSplit(element[col])" (click)="textClickEvent(element)"></td>
                </ng-container>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!disableColHeaders">
        <tr mat-header-row *matHeaderRowDef= "displayedColumns; sticky: true"></tr>
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'table-row-color': row.color}"></tr>
</table>
</div>